import { writable } from 'svelte/store';

export const notifications = writable([]);

let id = 0;

function push(type, message, duration = 4000) {
    const item = {
        id: ++id,
        type,
        message
    };

    notifications.update((n) => [...n, item]);

    setTimeout(() => {
        notifications.update((n) =>
            n.filter((x) => x.id !== item.id)
        );
    }, duration);
}

export const notify = {
    success: (msg) => push('success', msg),
    error: (msg) => push('error', msg, 6000),
    warning: (msg) => push('warning', msg),
    info: (msg) => push('info', msg)
};